/* eslint-disable react/jsx-props-no-spreading */
// import { useMemo } from 'react';
import { Col, Row, Form, Input, Button, Divider, Tag } from 'antd';
import { DeleteOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { validateFileList } from 'utils/form/validators';
import { UploadMedia, Accordion, AddButton } from 'components';
import './Verificadores.scss';
import '../../../../Formulario.scss';
import * as fieldMsgs from 'constants/formFieldsMessages';

const DocumentacionRecibida = ({ form, isLoadingImages }) => {
  const { TextArea } = Input;

  const formComponent = ({ remove, name, disabled, isLastDocumentacion, ...restField }) => (
    <div>
      <div className="formulario-hallazgos">
        <Row gutter={24}>
          <Col xs={10}>
            <span className="instruction-span-red">*&nbsp;</span>
            <span
              className="instruction-span-purple"
              style={{ paddingLeft: '2px', marginBottom: '5px' }}>
              Completa la información solicitada de la documentación recibida para realizar el
              registro correctamente.
            </span>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={12} className="formulario-hallazgos-tabla-header">
            <span className="instruction-span-red">*&nbsp;</span>
            Información de la documentación:
          </Col>
          <Col xs={9} className="formulario-hallazgos-tabla-header">
            <span className="instruction-span-red">*&nbsp;</span>
            Muestras de documentación aprobatoria:
          </Col>
          <Col xs={3} style={{ textAlign: 'center' }} className="formulario-hallazgos-tabla-header">
            Acciones
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="hallazgos-detalle">
            <Row gutter={[7, 0]} className="row-formulario-nested">
              <Col span={12}>
                <Form.Item
                  {...restField}
                  className=""
                  name={[name, 'tipoDocumento']}
                  label="Tipo de documento:"
                  rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                  <Input placeholder="Tipo de documento" style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  {...restField}
                  className=""
                  name={[name, 'cantidad']}
                  label="Cantidad de documentos:"
                  rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                  <Input placeholder="Cantidad de documentos" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[7, 0]} className="row-formulario-nested">
              <Col span={24}>
                <Form.Item
                  {...restField}
                  className=""
                  name={[name, 'observaciones']}
                  label="Observaciones del documento:"
                  rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                  <TextArea
                    showCount
                    maxLength={500}
                    placeholder="Observaciones del documento"
                    style={{ height: 120, resize: 'none', width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col xs={9}>
            <div className="hallazgos-imagenes">
              <span className="subtitulo-descripcion">Captura de 2 a 5 muestras.</span>
              <div className="hallazgos-imagenes-row">
                <Form.Item
                  {...restField}
                  required
                  name={[name, 'muestra_1']}
                  label="Muestra 1"
                  className="hallazgos-imagenes-muestra"
                  rules={[
                    {
                      validator: validateFileList
                    }
                  ]}>
                  <UploadMedia disabled={isLoadingImages} loading={isLoadingImages} />
                </Form.Item>
                <Form.Item
                  required
                  {...restField}
                  name={[name, 'muestra_2']}
                  label="Muestra 2"
                  className="hallazgos-imagenes-muestra"
                  rules={[
                    {
                      validator: validateFileList
                    }
                  ]}>
                  <UploadMedia disabled={isLoadingImages} loading={isLoadingImages} />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, 'muestra_3']}
                  label="Muestra 3"
                  className="hallazgos-imagenes-muestra">
                  <UploadMedia disabled={isLoadingImages} loading={isLoadingImages} />
                </Form.Item>
              </div>
              <div className="hallazgos-imagenes-row">
                <Form.Item
                  {...restField}
                  name={[name, 'muestra_4']}
                  label="Muestra 4"
                  className="hallazgos-imagenes-muestra">
                  <UploadMedia disabled={isLoadingImages} loading={isLoadingImages} />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, 'muestra_5']}
                  label="Muestra 5"
                  className="hallazgos-imagenes-muestra">
                  <UploadMedia disabled={isLoadingImages} loading={isLoadingImages} />
                </Form.Item>
              </div>
            </div>
          </Col>
          <Col xs={3}>
            <div className="hallazgos-imagenes-acciones">
              <Button disabled={isLastDocumentacion} style={{ height: '2em' }}>
                <DeleteOutlined onClick={() => remove(name)} />
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );

  return (
    <div className="modal-monitoreo-internet-hallazgos">
      <Row gutter={[24, 0]} className="row-formulario" style={{ marginBottom: '11px' }}>
        <Col span={24} className="col-dos-instrucciones">
          <span className="instruction-span-purple" style={{ paddingLeft: '9px' }}>
            Agrega los registros necesarios.
          </span>
          <Tag
            className="instruction-span-pink"
            icon={<ExclamationCircleFilled style={{ fontSize: '10px' }} />}
            bordered={false}
            color="magenta"
            style={{ marginBottom: '6px', paddingLeft: '9px' }}>
            El registro de designados por el sujeto obligado es opcional. Si realizas el registro
            completa todos los campos solicitados.
          </Tag>
        </Col>
      </Row>
      <Form layout="vertical" form={form}>
        <Form.List name="documentaciones" initialValue={[{}]}>
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map(({ key, name, ...restField }) => {
                  // const isLastDocumentacion = fields.length <= 1;

                  const documentacion = {
                    key: `documentacion_${key}`,
                    label: `Documentación ${name + 1}`,
                    forceRender: true,
                    children: formComponent({
                      remove,
                      name,
                      // isLastDocumentacion,
                      ...restField
                    })
                  };
                  return (
                    <Accordion
                      key={key}
                      items={[documentacion]}
                      defaultActiveKey={['documentacion_0']}
                    />
                  );
                })}
                <Divider />
                <div className="formulario-hallazgos-acciones">
                  <AddButton
                    onClick={() => {
                      add();
                    }}
                    style={{ marginRight: '1em' }}>
                    Agregar Nuevo
                  </AddButton>
                </div>
              </>
            );
          }}
        </Form.List>
      </Form>
    </div>
  );
};

DocumentacionRecibida.propTypes = {
  // form: PropTypes.shape({}).isRequired,
  form: PropTypes.shape({ getFieldsValue: PropTypes.func, getFieldValue: PropTypes.func })
    .isRequired,
  isLoadingImages: PropTypes.bool.isRequired
};

export default DocumentacionRecibida;
